module.exports = __webpack_public_path__ + "img/27.1a3ea323.png";